import React, {Component} from 'react';
import {
    Input,
    Label,
    Col,
    FormGroup,
    Form,
    Button,
    FormFeedback
} from 'reactstrap';
import _ from 'lodash';
import './AddAssistantComponent.css';
import PropTypes from 'prop-types';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {ASSISTANT_TYPES} from "../../../constants/constants";
import {Utils} from "../../../utils/utils";
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";
import Select from "../../commonComponents/customSelect/CustomSelect.container";
import {Redirect} from "react-router-dom";

const requiredSelectFields = ['roles', 'country'];

class AddAssistantComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            roles: [],
            firstName: '',
            lastName: '',
            email: '',
            continent: this.props.continentCode,
            country: '',
            requiredFieldError: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.orgContinent !== nextProps.continentCode) {
            this.setState({continent: nextProps.continentCode})
        }
    }

    componentWillUnmount() {
        this.props.onContinentSet('');
    }

    render() {
        if (this.props.success) {
            return <Redirect to='/assistants-management' push />
        }

        return (
            <div className='add-assistant-container'>
                <FormWrapper>
                    <BackButtonComponent path='/assistants-management'
                                         label={_.get(this.props.translation, sharedLabelsPath.back_button)}/>
                    <div className='add-assistant-form-container'>
                        <h4 className='page-label'>{_.get(this.props.translation, 'assistants.add_assistant_page_label')}</h4>
                        {this.renderContent()}
                    </div>
                </FormWrapper>
            </div>
        );
    }

    renderContent = () => {
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }

        return (
            <Form className='add-assistant-form' onSubmit={this.handleSubmit}>
                {this.renderFormGroups()}
                <div className='button-group'>
                    <Button type="submit" className="olive-green-btn">
                        {_.get(this.props.translation, sharedLabelsPath.add_button)}
                    </Button>
                </div>
            </Form>
        )
    };

    renderFormGroups = () => {
        let paramsList = [
            {
                value: 'roles',
                title: _.get(this.props.translation, 'assistants.roles_label'),
                type: 'select',
                isRequired: true,
                isMulti: true,
                content: Utils.getOptions(
                    _.map(ASSISTANT_TYPES, value => ({
                        code: value,
                        name: _.get(this.props.translation, 'assistants.' + value + '_label')
                    }))
                ),
                placeholder: _.get(this.props.translation, 'assistants.roles_select_placeholder'),
                onChange: this.handleChangeRoleSelect
            },
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.first_name_label)
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.last_name_label)
            },
            {
                value: "email",
                type: "email",
                title: _.get(this.props.translation, sharedLabelsPath.email_label),
                isRequired: true,
                placeholder: _.get(this.props.translation, sharedLabelsPath.email_label)
            },
            {
                value: "continent",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder),
                onChange: this.handleChangeContinent,
                isRequired: true,
                isDisabled: !this.props.continents
            },
            {
                value: "country",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries)
                ),
                placeholder: _.get(this.props.translation, sharedLabelsPath.country_input_placeholder),
                isRequired: true,
                isDisabled: !this.props.countries
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)]
    };

    handleChangeContinent = (selectedOption) => {
        this.props.onContinentSet(selectedOption.value);
        this.setState({country: ''});
    };

    getFormGroup = (params) => {
        if (params.type === 'select') {
            return this.getSelectFormGroup(params);
        }
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                           value={_.get(this.state, params.value)}
                           onChange={params.onChange || this.handleChange(params.value)}
                           placeholder={params.placeholder}
                           disabled={params.isDisabled}
                           required={params.isRequired}
                           invalid={_.isNil(this.props.errors) ? false : this.props.errors.includes(params.value)}>
                        {params.content}
                    </Input>
                    <FormFeedback>{params.errorMessage || ''}</FormFeedback>
                </Col>
            </FormGroup>
        );
    };

    getSelectFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        let selectedOption = params.isMulti ?
            _.filter(params.content, option => this.state[params.value].includes(option.value)) :
            _.find(params.content, option => option.value === this.state[params.value]);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3}>{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Select id={id}
                            isMulti={params.isMulti}
                            selectedOption={selectedOption}
                            options={params.content}
                            onSelect={params.onChange || this.handleChangeSelect(params.value)}
                            placeholder={params.placeholder}
                            disabled={params.isDisabled}
                            requiredFieldError={this.state.requiredFieldError === params.value}
                    />
                </Col>
            </FormGroup>
        );
    };

    handleChangeRoleSelect = (selectedOptions) => {
        this.setState({roles: _.map(selectedOptions, option => option.value)});
    };

    handleChangeSelect = (fieldName) => (selectedOption) => {
        this.setState({[fieldName]: selectedOption.value});
    };

    handleChange = (fieldName) => (e) => {
        this.setState({[fieldName]: e.target.value});
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (this.checkRequiredSelectFields()) {
            return;
        }

        let permissions = {
            hasRootPermission: false,
            hasFinancialManagerPermission: this.state.roles.includes(ASSISTANT_TYPES.FINANCIAL_ASSISTANT),
            hasProcessingManagerPermission: this.state.roles.includes(ASSISTANT_TYPES.PROCESS_ASSISTANT)
        };
        let data = {
            permissions,
            email: this.state.email,
            identityAlias: {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                countryCode: this.state.country
            }
        };

        this.props.onProcess(data);
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if ((!this.state[field] || _.isEmpty(this.state[field]))&& !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

AddAssistantComponent.propTypes = {
    translation: PropTypes.object.isRequired,
    success: PropTypes.bool,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    onProcess: PropTypes.func.isRequired,
    onContinentSet: PropTypes.func.isRequired
};

export default AddAssistantComponent;



// WEBPACK FOOTER //
// ./src/components/assistantsManagement/addAssistantComponent/AddAssistantComponent.js